(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .factory('LenderIntegrationSearch', LenderIntegrationSearch);

    LenderIntegrationSearch.$inject = ['$resource'];

    function LenderIntegrationSearch($resource) {
        var resourceUrl =  'api/_search/lender-integrations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
